export enum FileUploadStatusType {
    Canceled = 'Canceled',
    Completed = 'Completed',
    Failed = 'Failed',
    InProgress = 'InProgress',
    Started = 'Started'
}
